import { STATES } from '../../../constants';

export function ShareMoveConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_SHARE_MOVE, {
    abstract: true,
    url: '/moving-announcement',
    when: STATES.STEP_SHARE_MOVE_CUSTOMIZE,
    title: 'Moving Announcement',
    scrollTop: true,
    data: {
      moveItem: {
        type: 'share',
        singleton: false,
      },
    },
  });
}
